import { render, staticRenderFns } from "./debris.vue?vue&type=template&id=10d988a2&scoped=true"
import script from "./debris.vue?vue&type=script&lang=js"
export * from "./debris.vue?vue&type=script&lang=js"
import style0 from "./debris.vue?vue&type=style&index=0&id=10d988a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d988a2",
  null
  
)

export default component.exports